// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__cd320","closeButton":"Modal__closeButton__3Gb6I","root":"Modal__root__3mziL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 456
// module chunks = 0